import React 					from 'react';
import ReactDOM 				from 'react-dom';
import BLComponent				from '../core/_BLComponent.jsx';

export default class InventoryComparisonItemListRow extends BLComponent
{
	resetHiddenImg() {
		var itemImgs = document.getElementsByClassName("itemImg");
		var itemErrorImgs = document.getElementsByClassName("itemErrorImg");

		for(const itemErrorImg of itemErrorImgs) {
			itemErrorImg.style.display = "none";
		}
		
		for(const itemImg of itemImgs) {

			if (itemImg.style.display == "none") {
				itemImg.style.display = "block";
			}			
		}
	}
	render() {
		const {data, item, keyRow, settings} = this.props;
		var invAImgURL;
		var invBImgURL;
		this.resetHiddenImg();

		const blSource = ( ( item.invASource == "BrickLink" )?0:( item.invBSource == "BrickLink" )?1:-1 ); /* 0 : InvA : BL, 1: InvB: BL, -1 : Lego for both A and B */

		if (!settings.showLegoData) 
		{
			if ( ( item.invASource == "Lego" ) && ( item.invBSource != "Lego") )
			{
				invAImgURL = item.invBImgURL; 
			}

			if ( ( item.invBSource == "Lego" ) && ( item.invASource != "Lego") )
			{
				invBImgURL = item.invAImgURL; 
			}

		}

		invAImgURL = ( (item.invASource == "Lego") && (item.invAQty == 0) )?"":item.invAImgURL;
		invBImgURL = ( (item.invBSource == "Lego") && (item.invBQty == 0) )?"":item.invBImgURL;

		var isExistingInRegular = (data.listType == 1)?false:true;
		
		if ( ( typeof data.regularItemList != "undefined" ) && (data.listType == 1) )
		{

			for(var i=0; i < data.regularItemList.length;i++) {
				var regularItem = data.regularItemList[i];
				var regularItemNo = (blSource == 0)?regularItem.invAItemNo:(blSource == 1)?regularItem.invBItemNo:"";
				var regularItemColorName = (blSource == 0)?regularItem.invAColorName:(blSource == 1)?regularItem.invBColorName:"";

				var extraItemNo = (blSource == 0)?item.invAItemNo:(blSource == 1)?item.invBItemNo:"";
				var extraItemColorName = (blSource == 0)?item.invAColorName:(blSource == 1)?item.invBColorName:"";

				{
					if ( (regularItemNo == extraItemNo) && (regularItemColorName == extraItemColorName) ) {
						isExistingInRegular = true;
					}
				}
			}
		}

		const itemAImgKey = (item.invAItemNo + "_" + item.invAColorName + "_"+item.invAPCC + "_a_" + data.listType).replaceAll(",", '_'); 
		const itemBImgKey = (item.invBItemNo + "_" + item.invBColorName + "_"+item.invBPCC + "_b_" + data.listType).replaceAll(",", '_'); 

		return(
				<React.Fragment>
					<div className={"inventory-comparison__item-list ic-row inventory-comparison__grid-xl inventory-comparison__grid-xl-item inventory-comparison__grid-split-y inventory-comparison__grid-cell-hide-small-screen" + ((!isExistingInRegular)?" inventory-comparison__extra-item-not-in-inventory":"") } key={keyRow + "1"}>
						<div className="inventory-comparison__grid-xl-cell--image text--left l-pad--sm">
							{this.renderImageField(invAImgURL, itemAImgKey, 1)}
						</div>
						
						{this.renderItemNoField( 0 )}
						<div className="text--left l-pad--sm inventory-comparison__grid-xl-cell--item-name inventory-comparison__grid-cell-hide-small-screen">
							<div>
								<div><strong>{/*(settings.showLegoData && item.invASource == "Lego" && item.invAItemName_LEGO != "")?item.invAItemName_LEGO:item.invAItemName*/ this.renderItemNameField(0)}</strong></div>
								{ this.renderItemCodeField( 0, 0 ) /* (item.invASource == "Lego")? this.renderElementField(item.invAPCC): this.renderPCCField(item.invAPCC)*/ }
								{ ( !isExistingInRegular )&& <div className="inventory-comparison__text--tiny"><i className="fas fa-exclamation-circle"></i> This extra has no inventory match</div> }
							</div>
						</div>
						<div className="text--left l-pad--sm inventory-comparison__grid-xl-cell--color inventory-comparison__grid-cell-hide-small-screen">
							{this.renderColorField(0)}
						</div>
						<div className="text--center l-pad--sm inventory-comparison__grid-cell-hide-small-screen">
							<div className={ "l-flex l-center-v l-full-height " + ( ( (item.invAQty != item.invBQty) && (item.invAQty != 0) )?"inventory-comparison__color-error-field":null) }><div className="l-margin-y--auto">{item.invAQty}</div></div>
						</div>
						<div className="text--center l-pad--sm inventory-comparison__grid-cell-hide-small-screen">
							<div className={ "l-flex l-center-v l-full-height " + ( ( (item.invAQty != item.invBQty) && (item.invBQty != 0) )?"inventory-comparison__color-error-field":null) }><div className="l-margin-y--auto">{item.invBQty}</div></div>
						</div>
						<div className="text--left l-pad--sm inventory-comparison__grid-xl-cell--color inventory-comparison__show-sitewidthxl">
							<div className="l-flex">{this.renderColorField(1)}</div>
						</div>
						<div className="text--left l-pad--sm inventory-comparison__grid-xl-cell--item-name inventory-comparison__show-sitewidthxl">
							<div>
								<div><strong>{ /*(settings.showLegoData && item.invBSource == "Lego" && item.invBItemName_LEGO != "")?item.invBItemName_LEGO:( (item.invBItemName != "")?item.invBItemName:(item.invBItemName_LEGO !="")?item.invBItemName_LEGO:"--")*/this.renderItemNameField(1)}</strong></div>
								{ this.renderItemCodeField(1, 1)/*(item.invBSource == "Lego")? this.renderElementField(item.invBPCC): this.renderPCCField(item.invBPCC) */}
							</div>

						</div>
						<div className="text--left l-pad--sm inventory-comparison__show-sitewidthxl">
							{this.renderItemNoField( 1 )}
						</div>
						<div className="text--center l-pad--sm inventory-comparison__show-sitewidthxl  inventory-comparison__grid-xl-cell--image">
							{this.renderImageField(invBImgURL, itemBImgKey, 2)}
						</div>
					</div>
					<div className="inventory-comparison__grid-xl inventory-comparison__grid-xl-item inventory-comparison__grid-cell-show-small-screen l-pad-y--sm" key={keyRow + "2"}>
						<div>
							<div>
								<img  className="inventory-comparison__grid-xl-small-cell--image" src={item.invAImgURL}/>
							</div>
							<div>
								{item.invAItemNo}
							</div>
						</div>
						<div className="inventory-comparison__grid-xl-cell-small-description">
							<div>
								<strong>{(settings.showLegoData && item.invASource == "Lego" && item.invAItemName_LEGO != "")?item.invAItemName_LEGO:item.invAItemName}</strong>
							</div>
							<div>
								{this.renderColorField( 0)}
							</div>
							<div>
								{ this.renderItemCodeField( 0, 2 )} 
							</div>
							<div className="l-flex l-split l-full-width">
								<div className="inventory-comparison__small-qty-section">
									<div>Qty A</div>
									<div className={ "l-pad--sm " + ( ( (item.invAQty != item.invBQty) && (item.invAQty != 0) )?"inventory-comparison__color-error-field":"inventory-comparison__color-small-qty-field") }>{item.invAQty}</div>
								</div>
								<div className="inventory-comparison__small-qty-section">
									<div>Qty B</div>
									<div className={"l-pad--sm " + ( ( (item.invAQty != item.invBQty) && (item.invBQty != 0) )?"inventory-comparison__color-error-field":"inventory-comparison__color-small-qty-field") }>{item.invBQty}</div>
								</div>
							</div>
						</div>
					</div>
					</React.Fragment>
				);	
	}

	renderItemNameField( target ) {
		const {item, settings} = this.props;
		
		const sourceItem = (target == 0)?{invSource: item.invASource, itemName:item.invAItemName, itemNameLego: item.invAItemName_LEGO, qty:item.invAQty}:{invSource: item.invBSource, itemName:item.invBItemName, itemNameLego: item.invBItemName_LEGO, qty:item.invBQty};
		const sourceItemOther = (target == 0)?{invSource: item.invBSource, itemName:item.invBItemName, itemNameLego: item.invBItemName_LEGO}:{invSource: item.invASource, itemName:item.invAItemName, itemNameLego: item.invAItemName_LEGO};
		
		const itemName = 	(sourceItem.invSource != "Lego")?
								sourceItem.itemName
							:
								(sourceItem.qty == 0)?
									""
								:
									(settings.showLegoData)?
										sourceItem.itemNameLego
									:
										(sourceItem.itemName != "")?
											sourceItem.itemName
										:
											(sourceItemOther.itemName != "")?
												sourceItemOther.itemName
											:
												"";
		
		if (itemName != "") {
			return(
				<React.Fragment>
					{blapp.util.decodeHtml(itemName)}
				</React.Fragment>
			)
		} 
		else
		{
			return(
				<React.Fragment>
					--
				</React.Fragment>
			)
		}
	}

	renderColorField( target) {

		const {item, settings} = this.props;
		
		const sourceItem = (target == 0)?{invSource: item.invASource, colorName:item.invAColorName, colorNameLego: item.invAColorName_LEGO, colorRGB: item.invAColorRGB, qty:item.invAQty}:{invSource: item.invBSource, colorName:item.invBColorName, colorNameLego: item.invBColorName_LEGO, colorRGB: item.invBColorRGB, qty: item.invBQty};
		const sourceItemOther = (target == 0)?{invSource: item.invBSource, colorName:item.invBColorName, colorNameLego: item.invBColorName_LEGO, colorRGB: item.invBColorRGB}:{invSource: item.invASource, colorName:item.invAColorName, colorNameLego: item.invAColorName_LEGO, colorRGB: item.invAColorRGB};

		const colorName = (sourceItem.invSource != "Lego")?sourceItem.colorName:(sourceItem.qty == 0)?"":(settings.showLegoData)?sourceItem.colorNameLego:(sourceItemOther.colorName == "")?sourceItem.colorNameLego:sourceItemOther.colorName;
		//const colorRGB  = (sourceItem.colorRGB != "")?sourceItem.colorRGB:sourceItemOther.colorRGB;
		const colorRGB  = (sourceItem.colorRGB != "")?sourceItem.colorRGB:null;
		
		if (colorName != "")
		{
			return(
				<div className="l-flex">
					{ this.renderColorBox(colorRGB) }<div className="l-margin-left--sm">{colorName}</div>
				</div>
			)
		}
		else
		{
			return(
				<div className="l-flex">
					{ this.renderColorBox("") }
					<div className="l-margin-left--sm">--</div>
				</div>
			)
		}
	}

	renderColorBox(colorRGB) {
		if ( (colorRGB != null) && (colorRGB != "") ) {
			if ( colorRGB == "#") {
				return (
					<div className="inventory-comparison__color-box"></div>
				)
			}
			else {
				return (
					<div className="inventory-comparison__color-box" style={{"backgroundColor":colorRGB}}></div>
				)
			}
		}
		else
		{
			return (
				<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				   <rect x="2.5" y="2.5" width="19" height="15" rx="4" fill="#fff" stroke="#D8DBDF"/>
				   <path d="m4.5 15.5 15-11" stroke="#D80000" strokeLinecap="square"/>
				</svg>
			)
		}
	}

	renderItemCodeField( target, fieldType ) {
		const {item, settings} = this.props;
		
		const sourceItem = (target == 0)?{invSource: item.invASource, itemCode:item.invAPCC, qty:item.invAQty}:{invSource: item.invBSource, itemCode:item.invBPCC, qty:item.invBQty};
		const sourceItemOther = (target == 0)?{invSource: item.invBSource, itemCode:item.invBPCC, qty:item.invBQty}:{invSource: item.invASource, itemCode:item.invAPCC, qty:item.invAQty};

		const itemCodes = (sourceItem.invSource != "Lego")?sourceItem.itemCode:(settings.showLegoData || (sourceItemOther.itemCode == ""))?sourceItem.itemCode:sourceItemOther.itemCode;
		const codeTitle = (sourceItem.invSource != "Lego")?"PCC":( settings.showLegoData )?"Element": (sourceItem.qty == 0)?"Element":(!settings.showLegoData && (sourceItemOther.itemCode == ""))?"Element":"PCC";
		const itemCodeMap = itemCodes.map( (itemCode, idx) => { 
			if ((idx == 0) && (itemCode != 0) ) {
				return( <span key={itemCode + idx + "_" + target + "-" + fieldType}>{itemCode}</span>); 
			} 
			if ((idx > 0) && (itemCode != 0) ) {
				return( <span key={itemCode + idx + "_" + target + "-" + fieldType}>, {itemCode}</span>); 
			} 
			
		} );

		if ( itemCodes[0] != null ) {
			if ( (itemCodes[0].length > 0) && !this.hasNoMatchingData(sourceItem, sourceItemOther) )
			{
				const id = itemCodes[0] + "_" + target;
				return( 
					<div className="inventory-comparison__text--tiny">
						{codeTitle}: {itemCodeMap}
					</div>
				);
			}
			else
			{
				return( 
					<div className="inventory-comparison__text--tiny">
						<div>{codeTitle}: --</div>
						<div><i className="fas fa-exclamation-circle"></i> This item has no matching data</div>
					</div>
				);
			}
		}
		else
		{
			return( 
				<div className="inventory-comparison__text--tiny">
					<div>{codeTitle}: --</div>
					<div><i className="fas fa-exclamation-circle"></i> This item has no matching data</div>
				</div>
			);
		}
	}

	renderItemNoField(target) {
		const {item, settings} = this.props;
		const sourceItem = (target == 0)?{invSource: item.invASource, itemNo:item.invAItemNo, qty:item.invAQty}:{invSource: item.invBSource, itemNo:item.invBItemNo, qty:item.invBQty};
		const sourceItemOther = (target == 0)?{invSource: item.invBSource, itemNo:item.invBItemNo, qty:item.invBQty}:{invSource: item.invASource, itemNo:item.invAItemNo, qty:item.invAQty};
		const itemNo = (sourceItem.invSource != "Lego")?sourceItem.itemNo:(settings.showLegoData)?sourceItem.itemNo:sourceItemOther.itemNo;
		const catalogLinkUrl = (sourceItem.invSource != "Lego")?this.getCatalogLinkURL(item, target):"";

		if ( (item.itemNo != "") && !this.hasNoMatchingData(sourceItem, sourceItemOther) ){
			return(
				<div className="text--left l-pad--sm inventory-comparison__grid-cell-hide-small-screen inventory-comparison__grid-xl-cell--item-no">
					{(catalogLinkUrl.length > 0)?<a href={catalogLinkUrl}>{itemNo}</a>:<React.Fragment>{itemNo}</React.Fragment>}
				</div>
			)
		} 
		else
		{
			return(
				<div className="text--left l-pad--sm inventory-comparison__grid-cell-hide-small-screen inventory-comparison__grid-xl-cell--item-no">
					--
				</div>
			)
		}
	}

	renderImageField(imgUrl, key, imgFor) {
		const imgKey = blapp.util.decodeHtml(key).replace(/\s/g, '').replace(/\(/g, '').replace(/\)/g, '');
		
		if (imgUrl != "") {
			return (
				<div className="l-full-height l-flex l-center-v l-center">
					<img id={"img"+imgKey} className="itemImg inventory-comparison__grid-xl-cell--image" src={imgUrl} onError={()=>this.imgErrorProc(imgKey, imgFor) }/>
					<div id={"noimg"+imgKey} className="itemErrorImg l-center-v inventory-comparison__color-no-img-field l-full-height l-full-width text--center l-hide">
						<div className="l-margin-y--auto l-flex l-center-v l-center l-full-height">
							<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
							    <path fillRule="evenodd" clipRule="evenodd" d="m15.248 5.091-.312-.312a1.5 1.5 0 0 0-1.06-.44H7.5c-.828.003-1.5.675-1.5 1.503v8.497l1.5-1.5V5.842h4.999V7.84l1.5-1.5v-.376l.188.188 1.06-1.06zM8.656 17.34l2.421-2.42.422.42 2.734-2.733a.375.375 0 0 1 .53 0l.735.734v4H8.656zM7.5 18.497v.343h8.998V9.841h-.343l1.786-1.786c.037.132.057.27.057.408V18.84a1.5 1.5 0 0 1-1.5 1.5H7.5a1.5 1.5 0 0 1-1.42-1.016 1.992 1.992 0 0 0 1.163-.57l.257-.257zm2.934-8.591A1.499 1.499 0 0 0 8.5 11.34c0 .15.022.297.064.434l1.87-1.87z" fill="#0A1E32"/>
							    <path stroke="#000" strokeWidth="2" strokeLinecap="round" d="M18 5.253 4.414 18.839"/>
							</svg>
						</div>
					</div>
				</div>
			);
		}
		else
		{
			return (
				<div className="l-flex l-center-v inventory-comparison__color-no-img-field l-full-height text--center">
					<div className="l-margin-y--auto">
						<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						    <path fillRule="evenodd" clipRule="evenodd" d="m15.248 5.091-.312-.312a1.5 1.5 0 0 0-1.06-.44H7.5c-.828.003-1.5.675-1.5 1.503v8.497l1.5-1.5V5.842h4.999V7.84l1.5-1.5v-.376l.188.188 1.06-1.06zM8.656 17.34l2.421-2.42.422.42 2.734-2.733a.375.375 0 0 1 .53 0l.735.734v4H8.656zM7.5 18.497v.343h8.998V9.841h-.343l1.786-1.786c.037.132.057.27.057.408V18.84a1.5 1.5 0 0 1-1.5 1.5H7.5a1.5 1.5 0 0 1-1.42-1.016 1.992 1.992 0 0 0 1.163-.57l.257-.257zm2.934-8.591A1.499 1.499 0 0 0 8.5 11.34c0 .15.022.297.064.434l1.87-1.87z" fill="#0A1E32"/>
						    <path stroke="#000" strokeWidth="2" strokeLinecap="round" d="M18 5.253 4.414 18.839"/>
						</svg>
					</div>
				</div>
			)
		}
	}

	loadNextImage(key, imgSrc, idx, loadOk, loadErr) {
		var img = new Image();
        img.onload = function() {
			loadOk(key, imgSrc[idx]);
		} 

        img.onerror = function () { 
			if (idx >= ( imgSrc.length - 1)) {
				$("#img" + key).hide();
				$("#noimg" + key).show();
			}
			else {
				loadErr(key, imgSrc, idx+1, loadOk, loadErr);
			}
		};
        img.src = imgSrc[idx];
	}

	checkImage(imageSrc, good, bad) {
        var img = new Image();
        img.onload = good; 
        img.onerror = bad;
        img.src = imageSrc;
    }

	imgErrorProc(key, imgFor) {
		const {item} = this.props;
		
		const invSource = (imgFor == 1)?item.invASource:item.invBSource;
		const invPcc = (imgFor == 1)?item.invAPCC:item.invBPCC;
		
		//console.log("imgErrorProc " + imgFor + ":  " + invSource);
		//console.log(item);
		key = blapp.util.decodeHtml(key).replace(/\s/g, '').replace(/\(/g, '').replace(/\)/g, '');;

		if (invSource === "Lego") {
			const imgUrl = [
				"https://www.lego.com/cdn/product-assets/element.img.lod4photo.192x192/" + invPcc + ".jpg",
				"https://www.lego.com/cdn/product-assets/element.img.lod4outline.192x192/" + invPcc + ".jpg", 
				"https://www.lego.com/cdn/product-assets/element.img.photoreal.192x192/" + invPcc + ".jpg"
			];
			
			this.loadNextImage(key, imgUrl, 0, function(key, src){ $("#img" + key).attr("src", src); }, this.loadNextImage);
		}
		else {
			$("#img" + key).hide();
			$("#noimg" + key).show();
		}
	}

	hasNoMatchingData(sourceItem, sourceItemOther) {
		if (sourceItem.invSource == "Lego")
		{
			if (sourceItem.qty == 0) 
			{
				return true;
			}
			return false;
		}
	}

	getCatalogLinkURL(item, target) {
		const listItemTypeChar = { "Part": "P", "Minifigure": "M", "Set": "S", "Catalog":"C", "Book":"B", "Gear":"G" }; 	
		const itemType = listItemTypeChar[item.itemType];
		const itemNo = (target == 0)?item.invAItemNo:item.invBItemNo;
		const colorName = (target == 0)?item.invAColorName:item.invBColorName;
		const color = (colorName != "")?blapp.color.arrColor.filter(color => color.strColorName == colorName):[];
		const colorId = (color.length > 0)?color[0].idColor:-1;
		const url = "/v2/catalog/catalogitem.page?" + itemType + "=" + itemNo + ( (colorId > 0 )?"&idColor=" + colorId:"" ) ;
		return url;	
	}

}